var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('unit-form',{attrs:{"data":_vm.detailInfo},on:{"confirm":_vm.handleEditSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }